import React from "react";
import './index.less';

const CommentTitle = ({ title, required}) => {
  return (
    <div className={`comment-title ${required ? 'required': ''}`} dangerouslySetInnerHTML={{ __html: title }}></div>
  )
}

export default CommentTitle;